"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcAccordionBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var bc_tooltip_behavior_1 = require("../bc-tooltip/bc-tooltip-behavior");
var tooltip_constants_1 = require("../bc-tooltip/tooltip-constants");
var default_behavior_1 = require("./../../../common/models/default-behavior");
var bc_accordion_constants_1 = require("./bc-accordion-constants");
var BcAccordionBehavior = (function (_super) {
    __extends(BcAccordionBehavior, _super);
    function BcAccordionBehavior() {
        return _super.call(this) || this;
    }
    BcAccordionBehavior.setUpAll = function () {
        var accordionsGroup = Array.from(document.querySelectorAll("div[class~='".concat(bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDIONS_GROUPS_SUFIX, "']")));
        var elements = [];
        for (var _i = 0, accordionsGroup_1 = accordionsGroup; _i < accordionsGroup_1.length; _i++) {
            var element = accordionsGroup_1[_i];
            var bcAccordionsBehavior = new BcAccordionBehavior();
            bcAccordionsBehavior.setElement(element);
            bcAccordionsBehavior.setUp();
            elements.push(bcAccordionsBehavior);
        }
        return elements;
    };
    BcAccordionBehavior.prototype._setUp = function () {
        this._configureAccordions();
    };
    BcAccordionBehavior.prototype._configureAccordions = function () {
        var _this = this;
        var accordionList = this._getAccordions();
        accordionList.forEach(function (accordion, index) {
            _this._configureExpandEvent(accordion, index);
            _this._configureTooltipText(accordion);
            _this._configureAccessibility(accordion);
        });
    };
    BcAccordionBehavior.prototype._getHeader = function (accordion) {
        return accordion.querySelector(bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_HEADER);
    };
    BcAccordionBehavior.prototype._getContent = function (accordion) {
        return accordion.querySelector("section.".concat(bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_CONTENT_CLASS));
    };
    BcAccordionBehavior.prototype._configureTooltipText = function (accordion) {
        var tooltipText = accordion.querySelectorAll(".".concat(tooltip_constants_1.BC_TOOLTIP_SELECTOR));
        tooltipText.forEach(function (element) {
            if (tooltipText != null) {
                var bcTooltipBehavior = new bc_tooltip_behavior_1.BcTooltipBehavior();
                bcTooltipBehavior.setElement(element);
                bcTooltipBehavior.setUp();
                var attributte = element.getAttribute('bctooltiptext');
                element.setAttribute('aria-label', attributte);
            }
        });
    };
    BcAccordionBehavior.prototype._getAccordions = function () {
        return Array.from(this.mySelf.querySelectorAll(":scope > article[class~='".concat(bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_CLASS, "'],:scope >*>*> article[class~='").concat(bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_CLASS, "']")));
    };
    BcAccordionBehavior.prototype._configureExpandEvent = function (accordion, index) {
        var _this = this;
        if (accordion != null) {
            var header = this._getHeader(accordion);
            if (header !== null) {
                header.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) { return _this._handleOnClick(event, accordion, index); });
                header.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
                    return _this._handleOnKeyup(event, accordion, index);
                });
                header.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
                    return _this._handleOnKeydown(event);
                });
            }
            var expandedValue = header.classList.contains(bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_ACTIVE_CLASS);
            (0, helpers_1.addFocusable)(header, { expanded: String(expandedValue), level: '1', tabindex: '0' });
        }
    };
    BcAccordionBehavior.prototype._getIsSingle = function () {
        var _a, _b;
        var existsInChildren = this.mySelf.firstElementChild.hasAttribute('data-is-single');
        if (this.mySelf.hasAttribute('data-is-single') || existsInChildren) {
            return (((_a = this.mySelf.getAttribute('data-is-single')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true' ||
                ((_b = this.mySelf.firstElementChild.getAttribute('data-is-single')) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'true');
        }
        return false;
    };
    BcAccordionBehavior.prototype._toggleAccordionPanel = function (accordion, index) {
        var content = this._getContent(accordion);
        var header = this._getHeader(accordion);
        var accordionsGroup = accordion.closest(".".concat(bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDIONS_GROUPS_SUFIX));
        var isSingleDeprecated = accordionsGroup.classList.contains("".concat(bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_SINGLE_CLASS));
        var isDataIsSingle = this._getIsSingle();
        var accordions = this._getAccordions();
        for (var _i = 0, accordions_1 = accordions; _i < accordions_1.length; _i++) {
            var element = accordions_1[_i];
            if (element !== accordion && (isSingleDeprecated || isDataIsSingle)) {
                element.classList.remove("".concat(bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_ACTIVE_CLASS));
                element.querySelector('header').setAttribute('aria-expanded', 'false');
            }
        }
        var isPresent = accordion.classList.toggle("".concat(bc_accordion_constants_1.BcAccordionConstants.BC_ACCORDION_ACTIVE_CLASS));
        if (isPresent && this.activeFunction) {
            this.activeFunction(index);
        }
        header.setAttribute('aria-expanded', String(isPresent));
        content.setAttribute('tabindex', isPresent ? '0' : '-1');
    };
    BcAccordionBehavior.prototype._handleOnClick = function (event, accordion, index) {
        var currentEvnt = event.target;
        var parent = currentEvnt.parentNode;
        var isButton = currentEvnt.tagName.toLowerCase() === common_constants_1.BcCommonConstants.BUTTON_TAG ||
            parent.tagName.toLowerCase() === common_constants_1.BcCommonConstants.BUTTON_TAG;
        if (!isButton) {
            this._toggleAccordionPanel(accordion, index);
        }
    };
    BcAccordionBehavior.prototype._handleOnKeyup = function (event, accordion, index) {
        var allowedKeyCodes = [common_constants_1.BcCommonConstants.KEY_EVENT_ENTER, common_constants_1.BcCommonConstants.KEY_EVENT_SPACE];
        if (allowedKeyCodes.includes(event.code)) {
            this._toggleAccordionPanel(accordion, index);
        }
    };
    BcAccordionBehavior.prototype._handleOnKeydown = function (event) {
        if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
            event.preventDefault();
        }
    };
    BcAccordionBehavior.prototype._configureAccessibility = function (accordion) {
        var content = this._getContent(accordion);
        var header = this._getHeader(accordion);
        var headerId = header.getAttribute('id') || this._generateId('accordion-header');
        var contentId = content.getAttribute('id') || this._generateId('accordion-content');
        header.setAttribute('id', headerId);
        content.setAttribute('id', contentId);
        header.setAttribute('role', 'button');
        header.setAttribute('aria-expanded', 'false');
        header.setAttribute('aria-controls', contentId);
        content.setAttribute('role', 'region');
        content.setAttribute('aria-labelledby', headerId);
    };
    BcAccordionBehavior.prototype._generateId = function (componentType) {
        var array = new Uint32Array(1);
        var randomNumber = window.crypto.getRandomValues(array);
        return "".concat(componentType, "-").concat(randomNumber[0]);
    };
    return BcAccordionBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcAccordionBehavior = BcAccordionBehavior;
